import { env } from '@/utils/env'

/** Prefix seluruh key localStorage milik local mode. */
export const LOCAL_DB_STORAGE_PREFIX = 'mvdp-local-db'

/** Key persona aktif (user yang sedang "login" di local mode). */
export const LOCAL_DB_PERSONA_KEY = `${LOCAL_DB_STORAGE_PREFIX}:persona`

/** Key metadata (versi seed yang sedang terpasang). */
export const LOCAL_DB_META_KEY = `${LOCAL_DB_STORAGE_PREFIX}:__meta`

/** Simulasi latensi jaringan agar loading state ikut teruji. */
export const LOCAL_DB_LATENCY_MS = 120

/**
 * Local mode aktif bila `NEXT_PUBLIC_LOCAL_DB=true` (runtime `window.__ENV` atau `.env`).
 * Saat aktif, `client.api` dilayani oleh mock adapter berbasis jotai + localStorage,
 * sehingga service tetap memanggil endpoint Directus/NestJS yang sebenarnya.
 */
export function isLocalDbEnabled(): boolean {
  return String(env('NEXT_PUBLIC_LOCAL_DB') ?? '').toLowerCase() === 'true'
}
